/**
 * The currently-selected Branch (real backend entity —
 * `modules/platform/branch`, `GET /branches`), scoped under the
 * current Hospital. Nearly every clinical/financial write endpoint
 * requires a `branchId` — this is the one place the UI holds "which
 * branch is the user operating in right now" so feature modules don't
 * each re-derive it.
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface BranchSummary {
  id: string;
  code: string;
  name: string;
}

interface BranchState {
  currentBranch: BranchSummary | null;
  setBranch: (branch: BranchSummary | null) => void;
}

export const useBranchStore = create<BranchState>()(
  persist(
    (set) => ({
      currentBranch: null,
      setBranch: (branch) => set({ currentBranch: branch }),
    }),
    { name: 'nexao-branch' },
  ),
);
